<template>
  <router-view />
</template>

<script>
export default {
  name: 'AddonCenter'
}
</script>
